<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="会员编号：" prop="member_code">
                <span>{{model.member_code}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <span>{{model.cellphone}}</span>
            </el-form-item>
            <el-form-item label="商品名称：" prop="goods_name">
                <span>{{model.goods_name}}</span>
            </el-form-item>
            <el-form-item label="佣金比例：" prop="commission_tuan">
                <span>{{model.commission_tuan}}%</span>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
                <span>{{model.start_time}}</span>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <span>{{model.end_time}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{ transEnu(model.state, "act_state")}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="creator_id">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'promotionGoodsInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                commission_tuan: '',
                goods_id: '',
                goods_name: '',
                start_time: '',
                end_time: '',
                state: '',
                creator_id: '',
            },
            getObj:{
                url:'/api/admin/promotiongoods/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['act_state'],
        };
    },
    methods: {}
};
</script>